app.controller('forgetPasswordCtrl', function ($scope, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q) {

    $scope.user_reset = {
        Username: '',
        Password: '',
        Email: '',
        Notelp: ''
    };

    //$scope.Email = '';

    $scope.UserNID = '';
    $scope.back = function () {
        $window.location.href = "#/";
    }

    $scope.working = false;
    $scope.loadMessage = 'Loading...';

    $scope.modalMessage = {
        message: '',
        param: {}
    };



    $scope.submit = function () {
        console.log('email', $scope.user_reset);

        //captcha
        var challenge = grecaptcha.getResponse();
        if (!challenge) {
            alert("Mohon ulangi centang captcha");
            return false;
        }
        else {
            $scope.user_reset.challenge = challenge;
        }

        $scope.working = true;
        $http({
            method: 'POST',
            url: '/service/client.svc/Forget_Password',
            data: {
                UserForget: $scope.user_reset,

            },
        }).then(function (data) {
            $scope.working = false;
            if (data.data.d.result) {
                $scope.UserNID = data.data.d.UserNID;
                swal('Success', 'Please check your email', 'success').then(function () {
                    $window.location.href = "#/login/";
                });
            }
            else {
                swal('Error', 'error - ' + data.data.d.message, 'error');
            }


        }, function (error) {
            swal('Error', 'error ', 'error');
        });
    };

});
